export const ORDER_VISIBILITY = Object.freeze({
  STANDARD: 'standard',
  TABLE_ORDER: 'table_order',
  BOTH: 'both'
})

export const CATEGORY_VISIBILITY_FIELDS = [
  'menuActive',
  'orderVisibility',
  'visibilityRevision'
]

const VALID_ORDER_VISIBILITIES = new Set(Object.values(ORDER_VISIBILITY))

export const normalizeOrderVisibility = value =>
  VALID_ORDER_VISIBILITIES.has(value) ? value : ORDER_VISIBILITY.BOTH

export const orderVisibilityLabel = value => ({
  [ORDER_VISIBILITY.STANDARD]: 'Rozvoz / osobný odber',
  [ORDER_VISIBILITY.TABLE_ORDER]: 'Od stola',
  [ORDER_VISIBILITY.BOTH]: 'Oba spôsoby'
})[normalizeOrderVisibility(value)]

export const supportsCategoryVisibility = categories =>
  categories.some(category => CATEGORY_VISIBILITY_FIELDS.every(field =>
    Object.prototype.hasOwnProperty.call(category, field)
  ))

export const legacyActiveForCategory = category =>
  normalizeOrderVisibility(category?.orderVisibility) === ORDER_VISIBILITY.BOTH
    ? Boolean(category?.menuActive)
    : false

export const nextVisibilityRevision = value => {
  const revision = Number(value)
  return Number.isSafeInteger(revision) && revision >= 0 ? revision + 1 : 1
}

export const visibilityWriteMatches = (savedCategory, requestedCategory) =>
  Boolean(savedCategory) &&
  Boolean(savedCategory.menuActive) === Boolean(requestedCategory?.menuActive) &&
  normalizeOrderVisibility(savedCategory.orderVisibility) ===
    normalizeOrderVisibility(requestedCategory?.orderVisibility) &&
  Number(savedCategory.visibilityRevision) === Number(requestedCategory?.visibilityRevision)
